import * as moment from 'moment';
import { FormControl, FormGroup } from "react-bootstrap";

interface IProps {
    dateRange: number,
    status: number,
    isAdminLogin: boolean,
    onDateRangeChange: (dateRange: number) => void,
    onStatusChange: (status: number) => void
}

const BilledByToFilter = (props: IProps) => {
    const handleDateRangeChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        props.onDateRangeChange(parseInt(e.currentTarget.value));
    };

    const handleStatusChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        props.onStatusChange(parseInt(e.currentTarget.value));
    };

    const daysSince20220701 = moment().diff(moment('2022-07-01', 'YYYY-MM-DD'), 'days');

    return (
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <FormGroup style={{ marginBottom: 0, marginRight: 20 }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{ marginRight: 5 }}>Filter by Date Range:</div>
                    <div>
                        <FormControl
                            componentClass='select'
                            value={props.dateRange}
                            onChange={handleDateRangeChange}
                        >
                            <option value={0}>- Show All -</option>
                            {props.isAdminLogin && (
                                <option value={daysSince20220701}>- Since 7/1/2022 -</option>
                            )}
                            <option value={90}>Past 90 Days</option>
                            <option value={180}>Past 180 Days</option>
                            <option value={365}>Past Year</option>
                        </FormControl>
                    </div>
                </div>
            </FormGroup>

            <FormGroup style={{ marginBottom: 0, marginRight: 20 }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{ marginRight: 5 }}>Filter by Status:</div>
                    <div>
                        <FormControl
                            componentClass='select'
                            value={props.status}
                            onChange={handleStatusChange}
                        >
                            <option value={0}>- Show All -</option>
                            <option value={2}>Show Pending</option>
                            <option value={4}>Show Accepted</option>
                            <option value={5}>Show Auto Accepted</option>
                            <option value={8}>Show Disputed</option>
                        </FormControl>
                    </div>
                </div>
            </FormGroup>
        </div>
    );
}

export default BilledByToFilter;